import { render, staticRenderFns } from "./TableYasaipayHistory.vue?vue&type=template&id=06879f70&"
import script from "./TableYasaipayHistory.vue?vue&type=script&lang=js&"
export * from "./TableYasaipayHistory.vue?vue&type=script&lang=js&"
import style0 from "./TableYasaipayHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports